import { render, staticRenderFns } from "./TenantManagerInfo.vue?vue&type=template&id=0afe5784&scoped=true&"
import script from "./TenantManagerInfo.vue?vue&type=script&lang=js&"
export * from "./TenantManagerInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenantManagerInfo.vue?vue&type=style&index=0&id=0afe5784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe5784",
  null
  
)

export default component.exports